"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
var _lodash = _interopRequireDefault(require("lodash"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var bufferTools = _interopRequireWildcard(require("@/libs/bufferTools"));
var _AutoComplete = _interopRequireDefault(require("./AutoComplete"));
var _BufferSettings = _interopRequireDefault(require("./BufferSettings"));
var _StateBrowserBuffer = _interopRequireDefault(require("./StateBrowserBuffer"));
var _ChannelList = _interopRequireDefault(require("./ChannelList"));
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = {
  components: {
    AutoComplete: _AutoComplete.default,
    BufferSettings: _BufferSettings.default,
    Buffer: _StateBrowserBuffer.default,
    ChannelList: _ChannelList.default
  },
  props: ['network', 'sidebarState', 'activePrompt'],
  data: function data() {
    return {
      collapsed: false,
      channel_filter: '',
      channel_filter_display: false,
      channel_add_display: false,
      channel_add_input_has_focus: false,
      channel_add_input: '',
      show_channels: true,
      show_queries: true,
      show_channellist: false,
      // Onglet actif de la sidebar : 'channels' (Salons) ou 'queries' (Privés).
      activeTab: 'channels'
    };
  },
  computed: {
    serverBuffer() {
      return this.network.serverBuffer();
    },
    isActiveNetwork: function isActiveNetwork() {
      return this.$state.getActiveNetwork() === this.network;
    },
    totalNetworkCount() {
      return this.$state.networks.length;
    },
    serverUnread() {
      if (!this.collapsed) {
        return (0, _flags.default)(this.serverBuffer).unread;
      }
      let totalUnread = 0;
      this.network.buffers.forEach(buffer => {
        if (buffer.isSpecial()) {
          return;
        }
        totalUnread += (0, _flags.default)(buffer).unread;
      });
      return totalUnread;
    },
    serverHighlight() {
      if (!this.collapsed) {
        return (0, _flags.default)(this.serverBuffer).highlight;
      }
      let highlight = false;
      this.network.buffers.forEach(buffer => {
        if (buffer.isSpecial()) {
          return;
        }
        if ((0, _flags.default)(buffer).highlight) {
          highlight = true;
        }
      });
      return highlight;
    },
    filteredBuffers() {
      let filter = this.channel_filter;
      let filtered = [];
      if (!filter) {
        filtered = this.network.buffers;
      } else {
        filtered = _lodash.default.filter(this.network.buffers, buffer => {
          let name = buffer.name.toLowerCase();
          return name.indexOf(filter) > -1;
        });
      }
      return bufferTools.orderBuffers(filtered);
    },
    filteredBuffersByType() {
      let types = {
        other: [],
        channels: [],
        queries: []
      };
      this.filteredBuffers.forEach(bufferObj => {
        if (bufferObj.isChannel()) {
          types.channels.push(bufferObj);
        } else if (bufferObj.isQuery()) {
          types.queries.push(bufferObj);
        } else {
          // This is buffers like *raw, *bnc, *status etc
          types.other.push(bufferObj);
        }
      });
      types.channels = this.prioritiseAccueilBuffer(types.channels);
      Object.entries(types).forEach(([type, buffers]) => {
        // Always show channels type as it has join controls
        if (type !== 'channels' && !buffers.length) {
          delete types[type];
        }
      });
      return types;
    },
    suggestedChannelsList() {
      const networkid = this.network.id;
      const suggestedChannels = this.$state.setting('suggestedChannels');
      if (Array.isArray(suggestedChannels)) {
        return suggestedChannels.filter(c => !this.$state.getBufferByName(networkid, c.channel)).map(c => ({
          text: c
        }));
      }
      if (this.network.channel_list_state === '') {
        this.network.maybeUpdateChannelList();
      }
      return this.network.channel_list.filter(c => !this.$state.getBufferByName(networkid, c.channel)).sort((a, b) => b.num_users - a.num_users).map(c => ({
        text: c.channel,
        count: c.num_users,
        type: 'channel'
      }));
    },
    channelActivity() {
      return this.activityFromBuffers(this.filteredBuffersByType.channels);
    },
    queryActivity() {
      return this.activityFromBuffers(this.filteredBuffersByType.queries);
    },
    activeTabBuffers() {
      // Onglets Salons/Privés : seul le type actif est listé (switch).
      return this.filteredBuffersByType[this.activeTab] || [];
    },
    showBufferGroups() {
      return this.$state.setting('buffers.show_buffer_groups');
    },
    showPromptClose() {
      return this.activePrompt && this.activePrompt.type === 'queries' && this.activePrompt.value === this.network;
    }
  },
  watch: {
    // On tient App.vue au courant de l'onglet réellement affiché (y compris quand
    // l'utilisateur clique lui-même les onglets Salons/Privés) pour que burger et
    // « Messages » sachent s'ils doivent basculer d'onglet ou refermer le tiroir.
    activeTab(tab) {
      this.$state.$emit('statebrowser.tab.changed', tab);
    }
  },
  created() {
    // La barre de navigation mobile (App.vue) commande l'onglet affiché : le
    // burger rouvre le DERNIER onglet consulté (Salons/Privés, "collant"), le
    // bouton « Messages » force la vue « Privés ».
    this.listen(this.$state, 'statebrowser.tab', tab => {
      if (tab === 'channels' || tab === 'queries') {
        this.activeTab = tab;
      }
    });
  },
  methods: {
    activityFromBuffers(buffers) {
      let totalUnread = 0;
      let highlight = false;
      // buffers peut être undefined (type vide supprimé de filteredBuffersByType) :
      // le badge PV lit queryActivity même quand l'onglet Privés est vide.
      (buffers || []).forEach(buffer => {
        if (buffer.isSpecial() || buffer.setting('hide_message_counts')) {
          return;
        }
        totalUnread += (0, _flags.default)(buffer).unread;
        if (!highlight && (0, _flags.default)(buffer).highlight) {
          highlight = true;
        }
      });
      return {
        highlights: highlight,
        unread: totalUnread
      };
    },
    prioritiseAccueilBuffer(buffers) {
      return buffers.slice().sort((a, b) => {
        let aIsAccueil = this.isAccueilBuffer(a);
        let bIsAccueil = this.isAccueilBuffer(b);
        if (aIsAccueil === bIsAccueil) {
          return 0;
        }
        return aIsAccueil ? -1 : 1;
      });
    },
    isAccueilBuffer(buffer) {
      return buffer.name.toLowerCase().replace(/^[#&]+/, '') === 'accueil';
    },
    onNewChannelInputFocus() {
      // Auto insert the # if no value is already in. Easier for mobile users
      if (!this.channel_add_input) {
        this.channel_add_input = '#';
      }
      this.channel_add_input_has_focus = true;
    },
    onNewChannelInputBlur() {
      // Remove the # since we may have auto inserted it as they tabbed past
      if (this.channel_add_input === '#') {
        this.channel_add_input = '';
      }

      // If nothing was entered into the input box, hide it just to clean up the UI
      if (!this.channel_add_input) {
        this.channel_add_display = false;
      }
      this.channel_add_input_has_focus = false;
    },
    submitNewChannelForm() {
      let newChannelVal = this.channel_add_input;
      this.channel_add_input = '#';
      let network = this.network;
      let bufferObjs = Misc.extractBuffers(newChannelVal);

      // Only switch to the first channel we join if multiple are being joined
      let hasSwitchedActiveBuffer = false;
      bufferObjs.forEach(bufferObj => {
        let chanName = bufferObj.name;
        let ignoreNames = ['#0', '0', '&0'];
        if (ignoreNames.indexOf(chanName) > -1 || chanName.replace(/[#&]/g, '') === '') {
          return;
        }
        let newBuffer = this.$state.addBuffer(network.id, chanName);
        if (newBuffer && !hasSwitchedActiveBuffer) {
          this.$state.setActiveBuffer(network.id, newBuffer.name);
          hasSwitchedActiveBuffer = true;
        }
        if (bufferObj.key) {
          newBuffer.key = bufferObj.key;
        }
        if (network.isChannelName(chanName)) {
          network.ircClient.join(chanName, bufferObj.key);
        }
      });
    },
    onChannelFilterInputBlur() {
      // Hacky, but if we remove the channel filter UI at this blur event and the user
      // clicked a link in this filter UI, then the click event will not hit the target
      // link as it has been removed before the event reaches it.
      setTimeout(() => {
        this.closeFilterChannel();
      }, 200);
    },
    showMessageCounts(buffer) {
      return !buffer.setting('hide_message_counts');
    },
    setActiveBuffer(buffer) {
      // Clear any active component to show the buffer again
      this.$state.$emit('active.component', null);
      this.$state.setActiveBuffer(buffer.networkid, buffer.name);
      // Sur mobile la statebrowser est un tiroir qui recouvre le chat : on le
      // ferme dès qu'un salon est sélectionné, sinon il faut un 2e tap (sur le
      // chat) pour révéler le salon → effet « double clic pour afficher ».
      if (this.$state.ui.is_narrow) {
        this.$state.$emit('statebrowser.hide');
      }
    },
    showNetworkSettings(network) {
      network.showServerBuffer('settings');
      if (this.$state.ui.is_narrow) {
        this.$state.$emit('statebrowser.hide');
      }
    },
    showNetworkChannels(network) {
      network.showServerBuffer('channels');
      if (this.$state.ui.is_narrow) {
        this.$state.$emit('statebrowser.hide');
      }
    },
    openChannelList() {
      this.network.maybeUpdateChannelList();
      if (this.$state.ui.app_width <= 769) {
        // Mobile : afficher la liste des salons dans la sidebar (plein écran),
        // comme le searchlist ASL — pas de modal flottant. On ferme le
        // statebrowser (tiroir gauche, d'où vient le bouton) pour révéler le panneau.
        _GlobalApi.default.singleton().showInSidebar(_ChannelList.default, {
          network: this.network
        });
        this.$state.$emit('statebrowser.hide');
      } else {
        // Desktop : modal centré (inchangé).
        this.show_channellist = true;
      }
    },
    onSearchChannelClick() {
      // If we have no other buffers than the server buffer, take them straight
      // to the channel list for searching
      if (this.network.buffers.length > 1) {
        this.toggleFilterChannel();
      } else {
        this.network.showServerBuffer('channels');
      }
    },
    toggleAddChannel() {
      this.channel_add_display = !this.channel_add_display;
      this.channel_filter_display = false;
    },
    toggleFilterChannel() {
      this.channel_filter_display = !this.channel_filter_display;
      this.channel_add_display = false;
    },
    toggleSection(type) {
      if (type === 'channels') {
        this.show_channels = !this.show_channels;
      } else if (type === 'queries') {
        this.show_queries = !this.show_queries;
      }
    },
    promptClose() {
      const prompt = this.activePrompt;
      if (this.showPromptClose) {
        // Prompt is currently visible so close it
        prompt.type = undefined;
        prompt.value = undefined;
      } else {
        prompt.type = 'queries';
        prompt.value = this.network;
      }
    },
    closeQueries(buffers) {
      buffers.forEach(buffer => {
        this.$state.removeBuffer(buffer);
      });
    },
    closeFilterChannel() {
      this.channel_filter = '';
      this.channel_filter_display = false;
    },
    onNewChannelKeyDown(event) {
      if (!this.$refs.autocomplete) {
        return;
      }
      const autoComplete = this.$refs.autocomplete;
      if (event.key === 'Tab') {
        event.preventDefault();
        autoComplete.selectCurrentItem();
        return;
      }
      if (event.key === 'Escape') {
        this.channel_add_input = '';
        this.channel_add_display = false;
        return;
      }
      const item = autoComplete.selectedItem;
      if (event.key === 'Enter' && item && item.text === this.channel_add_input) {
        return;
      }
      this.$refs.autocomplete.handleOnKeyDown(event);
    },
    onNewChannelClick(value) {
      this.channel_add_input = value;
      this.submitNewChannelForm();
    },
    onNewChannelSelected(value) {
      this.channel_add_input = value;
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["StateBrowserNetwork"]
window._app_exports.components.StateBrowserNetwork = exports.default ? exports.default : exports;
